// extracted by mini-css-extract-plugin
export default {"wrapperStatistics":"Statistics_wrapperStatistics__bYNuJ","imageWrapper":"Statistics_imageWrapper__y-uOU","wrapperOneStatistics":"Statistics_wrapperOneStatistics__2OpJB"};